import { useState } from "react";
import Page from "../Page";
import ProductList from "./ProductList";
import CategoryModal from "./CategoryModal";
import { useAccess } from "src/hooks/useAccess.hook";
import { FEATURE } from "src/util/enums";

const ProductListing = () => {
  const [categoryModalOpen, setCategoryModalOpen] = useState(false);
  const isReadOnly = useAccess(FEATURE.PRODUCT_LIST, "R");

  const handleCategoryModalOpen = () => setCategoryModalOpen(true);
  const handleCategoryModalClose = () => setCategoryModalOpen(false);

  const handleCategoryAction = () => {
    setCategoryModalOpen(true);
  }

    return (
        <>
          <Page 
            title="Product | Smart-CMS"
            actions={
              isReadOnly
                ? []
                : [{ path: "/product-listing/new", text: "Add Product", icon: "eva:plus-fill" }]
            }
            addCategoryText={!isReadOnly ? "Add Category" : undefined}
            categoryAction={!isReadOnly ? handleCategoryAction : undefined}
          >
            <ProductList isReadOnly={isReadOnly} />
            <CategoryModal open={categoryModalOpen} onClose={handleCategoryModalClose} />
          </Page>
        </>
      );
}

export default ProductListing;